/**
 * Where a task image is shown from. A library entry, and so a task image chosen from here, is the
 * image's full URL; a task image chosen before that is a path under /images.
 */
export const taskImageSrc = (path: string) => (/^https?:\/\//.test(path) ? path : `/images/${path}`)
